import React from "react";
import { connect } from "react-redux";
import {
	CampaignBanner,
	SaleCampaignBannerContainer,
} from "../../containers/SalePromotionCampaign/SaleCampaign.style";
import SaleCampaignTimer from "./SaleCampaignTimer";
import delishopLogo from "../../assets/icons/delishop_logo2.svg";

export const SalePromotionCampaignBanner = ({
	props,
	campaign,
	resetCampaign,
}) => {
	return (
		<SaleCampaignBannerContainer>
			<CampaignBanner>
				<img
					src={campaign?.banner?.web ? campaign?.banner?.web : delishopLogo}
					alt={campaign?.name}
					loading="lazy"
					className="campaign-banner-img"
				/>
			</CampaignBanner>
			<SaleCampaignTimer
				type="start"
				campaign={campaign}
				resetCampaign={resetCampaign}
			/>
		</SaleCampaignBannerContainer>
	);
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => {
	return {};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(SalePromotionCampaignBanner);
